// Lib
import { get } from 'lodash/fp';
import { isCancel } from 'axios';
import http from '../../../../../../utils/services/http';

// Constants
import {
    IMAGE_SEARCH_SUBMIT,
    IMAGE_SEARCH_SUCCESS,
    IMAGE_SEARCH_FAILURE,
    IMAGE_SEARCH_SET_MODE,
    IMAGE_SEARCH_POPUP_MODE_DEFAULT,
} from './imageSearchPopupConstants';

import { TIMES } from '../../../../../../../common/utils/timeUtil';

const IMAGE_API_SEARCH_URL = 'images/search';

const getErrorMessage = get(['error', 'message']);

export const imageSearchPopupSetMode = (mode) => ({ type: IMAGE_SEARCH_SET_MODE, mode });

export const imageSearchPopupSubmit =
    (query, popupMode, offset = 0) =>
    (dispatch) => {
        if (!query || !query.length) return;

        dispatch({ type: IMAGE_SEARCH_SUBMIT, query });

        const lowercaseQuery = query.toLowerCase();

        const requestConfig = {
            url: IMAGE_API_SEARCH_URL,
            params: {
                query: lowercaseQuery,
                queryMode: popupMode === IMAGE_SEARCH_POPUP_MODE_DEFAULT ? 'reccomended' : 'search',
                offset,
            },
            timeout: TIMES.SECOND * 30,
        };

        return http(requestConfig)
            .then(({ data }) =>
                dispatch({
                    type: IMAGE_SEARCH_SUCCESS,
                    results: data.results,
                    query: lowercaseQuery,
                    total: data.total,
                }),
            )
            .catch((err) => {
                if (isCancel(err)) return;

                let error;

                if (err.response) {
                    error = getErrorMessage(err.response.data);
                } else {
                    error =
                        err.message && err.message.indexOf('timeout') === -1
                            ? err.message.toString()
                            : 'Sorry, something went wrong.';
                }

                dispatch({ type: IMAGE_SEARCH_FAILURE, error });

                return err;
            });
    };
